<opac-dialog [open]="isOpen()" [size]="'large'" [title]="('citations.dialog.title' | translate) + (record()?.title ?? '')" (closed)="closeCitationModal()">
  <div *ngIf="record()" class="container">
    <div class="cover">
      <opac-record-cover [coverUrl]="record().coverImageUrl" [showIcon]="false"></opac-record-cover>
    </div>

    <div class="data">
      <div class="details">
        <div *ngIf="record().title" class="detail">
          <span class="detail-title">{{ 'info.title' | translate }}</span>
          <span class="detail-description">{{ record().title }}</span>
        </div>

        <div *ngIf="record().publisher" class="detail">
          <span class="detail-title">{{ 'info.publisher' | translate }}</span>
          <span class="detail-description">{{ record().publisher }}</span>
        </div>

        <div *ngIf="record().author" class="detail">
          <span class="detail-title">{{ 'info.author' | translate }}</span>
          <span class="detail-description">{{ record().author }}</span>
        </div>

        <div *ngIf="record().publicationDate" class="detail">
          <span class="detail-title">{{ 'info.publicationYear' | translate }}</span>
          <span class="detail-description">{{ record().publicationDate | publicationDate }}</span>
        </div>
      </div>

      <div class="citation-details">
        <ng-container *ngIf="isLoading()">
          <opac-skeleton style="display: block; width: 33%; height: 16px; margin-bottom: 4px;"></opac-skeleton>
          <opac-skeleton style="display: block; width: 100%; height: 36px; margin-bottom: 16px;"></opac-skeleton>
          <opac-skeleton style="display: block; width: 100%; height: 150px;"></opac-skeleton>
        </ng-container>

        <ng-container *ngIf="!isLoading()">
          <opac-select [ngModel]="selectedStyle()" (ngModelChange)="setSelectedCitationStyle($event)">
            {{ 'citations.dialog.selectTitle' | translate }}
            <opac-option *ngFor="let style of styles()" [value]="style">{{ style.styleName }}</opac-option>
          </opac-select>

          <div #citationOutput class="citation-output" [innerHTML]="selectedStyle()?.value"></div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="actions" slot="actions">
    <opac-button [type]="'secondary'" (click)="copyToClipboard()">
      {{ 'citations.dialog.copy.button' | translate }}
    </opac-button>
  </div>
</opac-dialog>
